module.exports = __webpack_public_path__ + "img/icon_retweet.2ac28af3.svg";